import styled from 'styled-components';
import { spacing, colors, body2, fontWeights, Caption } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Divider } from 'ui/divider';

export const StyledContributionsCampaignsList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCampaignsListItem = styled.div`
  ${body2}
  display: flex;
  align-items: center;
  gap: ${spacing.base};
  justify-content: space-between;
`;

export const StyledPreviewThumbnail = styled.div`
  > a > div {
    margin-right: 0;
    height: ${pxToRem(40)};
    width: ${pxToRem(46)};
  }
`;

export const StyledLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const StyledTruncatedText2 = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${pxToRem(200)};

  width: 100%;
  box-sizing: border-box;
`;

export const StyledCampaignMetaData = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  /** unicode for bullet operators */
  > * + * {
    ::before {
      color: ${colors.grey35};
      content: '\\2219'; /** unicode for bullet operators */
      margin-right: ${spacing.quarter};
      font-weight: ${fontWeights.semiBold};
    }
    margin-left: ${spacing.quarter};
  }
`;

export const StyledSecondaryCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;

export const StyledFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFlex = styled.div`
  display: flex;
  gap: ${spacing.base};
  align-items: center;
`;

export const StyledDirectionalityLabel = styled(Caption)`
  flex-direction: column;
  display: inline-flex;
  justify-content: end;
  color: ${colors.textSecondary};
  font-weight: ${fontWeights.medium};
`;

export const StyledDirectionalityLegend = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
`;

export const StyledDirectionalityLegendMarker = styled.div`
  border-radius: 100%;
  width: ${spacing.threeQuarter};
  height: ${spacing.threeQuarter};

  &[data-directionality='down'] {
    background-color: ${colors.midnight80};
  }
  &[data-directionality='up'] {
    background-color: ${colors.cyan80};
  }
`;

export const StyledDivider = styled(Divider)`
  width: 100%;
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.threeQuarter};
`;

export const StyledSelectWrapper = styled.div`
  min-width: ${pxToRem(200)};
`;
export const StyledDirectionalityOptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  padding-left: ${spacing.quarter};
`;

export const StyledDirectionalityLegendWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledAlternateStateCard = styled.div`
  display: flex;
  flex-direction: column;
`;
